var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "console-wrap" },
    [
      _c("el-header", { staticClass: "my-el-header" }, [
        _c(
          "div",
          { staticClass: "header" },
          [
            _c("img", {
              staticClass: "jzq-logo",
              attrs: { src: "/images/logo/jzq-logo.png", alt: "" }
            }),
            _c(
              "el-button",
              {
                staticClass: "backBZ",
                attrs: { size: "small" },
                on: { click: _vm.goBackFn }
              },
              [_vm._v("返回上一步")]
            )
          ],
          1
        )
      ]),
      _c(
        "el-container",
        {
          staticStyle: { "overflow-x": "auto", "margin-bottom": "20px" },
          style: { "min-height": "100%" }
        },
        [
          _c("div", { staticClass: "main" }, [
            _vm.isRouterAlive
              ? _c("div", [_c("div", { staticClass: "bread" }), _c("nuxt")], 1)
              : _vm._e()
          ])
        ]
      ),
      _c("suspend")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c8bb9b8c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c8bb9b8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./layouts/editorFullLayout.vue
// module id = yIiW
// module chunks = 73